import { render, staticRenderFns } from "./ModuleFormDiyList.vue?vue&type=template&id=683631e6&scoped=true"
import script from "./ModuleFormDiyList.vue?vue&type=script&lang=js"
export * from "./ModuleFormDiyList.vue?vue&type=script&lang=js"
import style0 from "./ModuleFormDiyList.vue?vue&type=style&index=0&id=683631e6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683631e6",
  null
  
)

export default component.exports